import axios from 'axios'
import configData from './config.js'

const instance = axios.create({
  baseURL: configData.baseURL
})

export default instance